import React, { useState, useEffect } from 'react';
import { priceFormat } from 'newFunctions/sanitizeData'
import Styles from './styles.module.sass';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';

const ModuleSaldos = (props) => {
    const { data } = props;
    const {
        new_balance_cutting = 0,
        credit_available = 0,
        credit_imit = 0
    } = data || {};
    const history = useHistory();

    const [ showSaldo, setShowSaldo ] = useState(false);
    const [ usado, setUsado ] = useState(new_balance_cutting);
    const [ disponible, setDisponible ] = useState(credit_available);
    const [ limite, setLimite ] = useState(credit_imit);

    const handlePayment = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}movimientos-tarjeta`);
    }

    const toggleData = () => {
        setShowSaldo(!showSaldo);
    };

    useEffect(() => {
        if(data){
            setUsado(data?.new_balance_cutting)
            setDisponible(data?.credit_available)
            setLimite(data?.credit_imit)
        }
    },[data])

    return (
        <div className={`${Styles?.contSectionSaldos} ${Styles?.cardStyle}`}>
            <div className={Styles?.titleCard}>Saldo <span className={Styles?.handleClick} onClick={handlePayment}>Ver más</span></div>
            <div className={Styles?.contSell}>
                <div className={`${Styles?.contSellData} ${Styles?.topData}`}>
                    <p>Saldo utilizado</p>
                    <p>Saldo disponible</p>
                </div>
                <div className={Styles?.contSellData}>
                    <span>
                        <input type={!showSaldo ? "password" : "text"} readOnly className={Styles?.inputSell} value={ `$${priceFormat( usado )}` } />
                    </span>
                    <span className={Styles?.contEye}>
                        <input type={!showSaldo ? "password" : "text"} readOnly className={`${Styles?.inputSell} ${Styles?.inputSellLimit}`} value={ `$${priceFormat( disponible )}` } />
                        <div className={!showSaldo ? Styles?.eyePassNo : Styles?.eyePass } onClick={toggleData}>ojo</div>
                    </span>
                </div>
                <progress className={Styles?.progrssBar} id="file" value={ usado } max={ limite }></progress>
                <div className={Styles?.supConstSelData}>
                    <div className={Styles?.contSellData}>
                        <p>Límite de crédito</p>
                        <input type={!showSaldo ? "password" : "text"} readOnly className={`${Styles?.inputSell} ${Styles?.inputSellLimit}`} value={ `$${priceFormat( limite )}` } />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ModuleSaldos;